import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { ScrollableDiv } from './styles'

import { Button } from '@/components/ui/button'

import DropDownIcon from '@/assets/DropDownIcon'
import { cn } from '@/lib/utils'

interface AutoMoveTopRightPanelProps {
  accordionContent: React.ReactNode
  isAccordian: boolean
  moveDistance: number
  panelAction: React.ReactNode
  panelTitle: string
  setUseLongTitle: (value: boolean) => void
  shouldMove: boolean
  showself: boolean
}

export default function AutoMoveTopRightPanel({
  accordionContent,
  isAccordian,
  moveDistance,
  panelAction,
  panelTitle,
  setUseLongTitle,
  shouldMove,
  showself,
}: AutoMoveTopRightPanelProps) {
  const [openAccordian, setOpenAccordian] = React.useState(false)
  return (
    <AnimatePresence>
      {showself && (
        <motion.div
          className="shadow-legend"
          initial={{ x: 0 }}
          animate={{ x: shouldMove ? -moveDistance : 0 }}
          transition={{ damping: 30, stiffness: 300, type: 'spring' }}
        >
          <div
            className={cn(
              'w-full h-[52px] bg-white px-4 items-center flex justify-between min-w-[426px]',
              {
                'border-b-2': openAccordian,
              }
            )}
          >
            <div>{panelTitle}</div>

            <div className="flex items-center gap-1">
              {panelAction}
              {isAccordian && (
                <Button
                  variant="outline"
                  onClick={() => {
                    setOpenAccordian(!openAccordian)
                    setUseLongTitle(!openAccordian)
                  }}
                >
                  <DropDownIcon
                    className={cn(
                      `transform duration-300 ease-in-out ${
                        openAccordian ? 'rotate-0' : 'rotate-180'
                      }`
                    )}
                  />
                </Button>
              )}
            </div>
          </div>
          {isAccordian && (
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: openAccordian ? '100%' : 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white"
            >
              {openAccordian && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="p-4 pr-0 bg-white"
                >
                  <ScrollableDiv className="max-h-[580px] pb-5 pr-3">
                    {accordionContent}
                  </ScrollableDiv>
                </motion.div>
              )}
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
